<template>
  <div class="chart" :class="{ small: isSmall }">
    <header>
      <h2>Tohutu vaal võis olla ajaloo suurim</h2>
      <div class="lead">
        <div>
          Teadlased usuvad, et äsja avastatud iidne vaalaliik võis olla veelgi
          raskem kui sinivaal ehk seni maailma suurimaks loomaks peetud liik.
        </div>
      </div>
    </header>

    <main>
      <GN />
    </main>

    <footer>
      <div>
        Pildid: Alberto Gennari, Florent Goussard, Marco Merella, Trustees of
        the Natural History Museum
      </div>
      <div>Allikas: Nature © GRAPHIC NEWS</div>
    </footer>
  </div>
</template>

<style>
html.device-phone #vaal {
  margin-left: calc(var(--root-padding) * -1);
  margin-right: calc(var(--root-padding) * -1);
  overflow: hidden;
}
</style>

<style scoped>
.chart {
  --w: v-bind(containerWidth + "px");

  width: 100%;
  display: flex;
  flex-direction: column;

  position: relative;

  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-color);

  line-height: 1;
  font-size: 16px;

  background-color: var(--light);
  border-radius: 3px;

  box-sizing: border-box;
  padding: 1.55em 0.7em;
}

.small.chart {
  font-size: 12px;
}

header {
  display: flex;
  flex-direction: column;
  gap: 0.35em;

  align-items: center;
  text-align: center;

  margin-bottom: 0.7em;
}

header h2 {
  margin: 0 !important;
  font-size: 2em !important;
  line-height: 1.15 !important;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0 0.7em;

  position: relative;
}

header h2 span {
  white-space: nowrap;
}

.small header h2 {
  font-size: 1.55em !important;
}

.lead {
  position: absolute;
  z-index: 9;
  width: 100%;

  transform: translateY(110%);

  font-size: 1.1em;
  font-weight: 600;
  line-height: 1.1;

  /*  background-color: red;*/

  display: flex;
  justify-content: center;
}

.dark-theme .lead {
  background-color: var(--light);
}

.small .lead {
  font-size: 1em;
}

.lead > div {
  max-width: 550px;
}

main {
  position: relative;
}

.dark-theme main {
  /*  filter: grayscale(0.5);*/
}

footer {
  margin-top: 0.7em;

  width: 98%;
  align-self: center;

  font-size: 0.9em;
  font-weight: 600;
  line-height: 1.1;

  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.35em;
}

footer > div {
  max-width: 250px;
}

.small footer {
  font-size: 0.78em;
  font-weight: 400;
}
</style>

<script setup>
import {
  ref,
  computed,
  onMounted,
  onUnmounted,
  inject,
  nextTick,
  watch,
} from "vue";

import GN from "./GN.vue";

//
const containerElement = inject("containerElement");
const containerWidth = ref(0);
const isSmall = computed(() => {
  return containerWidth.value < 500;
});

// *** methods ***

function onResize() {
  const bounds = containerElement.getBoundingClientRect();
  const { width } = bounds;
  containerWidth.value = width;
}

//

onMounted(() => {
  window.addEventListener("resize", onResize);
  onResize();
  nextTick(onResize);
  window.setTimout(onResize, 1500);
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>
